import PortableText from "components/PortableText"
import PortableTitle from "components/shared/PortableTitle"
import { parseBackground, useSizing } from "lib/helpers"
import { SimpleHeader } from "schemas"
import { Container, styled, VStack } from "styled-system/jsx"

type Props = SimpleHeader

function Columns({
  title,
  body,
  showContainer,

  sizingTop,
  sizingBottom,
  backgroundColor1,
  backgroundColor2,
  backgroundStyle,
}: Props) {
  return (
    <styled.div
      className="simpleHeader"
      style={
        {
          background: parseBackground(
            backgroundColor1,
            backgroundColor2,
            backgroundStyle
          ),
          "--pt": useSizing(sizingTop) || "80px",
          "--pb": useSizing(sizingBottom) || "80px",
        } as React.CSSProperties
      }
      css={{
        pt: "var(--pt)",
        pb: "var(--pb)",
        // mt: "-120px",
      }}>
      <Container>
        <styled.div
          css={{
            rounded: "28px",
            background: showContainer ? "#DDE2FF" : undefined,
            textAlign: "center",
          }}>
          <VStack
            gap={{ base: 8 }}
            css={{
              p: "48px 24px 64px",
              lg: {
                p: 10,
              },
              // rounded: "28px",
              // background: "#DDE2FF",
              // textAlign: "center",
            }}>
            <PortableTitle
              as="h1"
              css={{
                color: "#000",
                fontFamily: "heading",
                fontSize: { base: "46px", md: "56px" },
                fontWeight: 600,
                lineHeight: "136%",

                "& em": {
                  background:
                    "linear-gradient(270deg, #DAA6FB 0%, rgba(218, 166, 251, 0.00) 94.48%)",
                  borderRadius: "0 50px 50px 0",
                  lineHeight: "56px",
                  boxDecorationBreak: "clone",

                  padding: "0px 10px",
                  margin: "0 -10px",

                  md: {
                    display: "inline-block",
                    padding: "2px 10px 6px 10px",
                    margin: "-2px -10px -6px -10px",
                  },
                },

                // "& em": {
                //   position: "relative",
                //   color: "transparent",
                //   whiteSpace: "nowrap",

                //   "&:after": {
                //     content: "attr(data-text)",
                //     display: "inline-flex",
                //     alignItems: "center",
                //     justifyContent: "center",
                //     color: "#000",
                //     position: "absolute",
                //     top: "50%",
                //     left: "50%",
                //     transform: "translate(-50%, -50%)",
                //     width: "calc(100% + .3em)",
                //     height: "80%",
                //     bg: "red",
                //     // rounded: "1em",
                //     rounded: "110px",
                //     background:
                //       "linear-gradient(270deg, #DAA6FB 0%, rgba(218, 166, 251, 0.00) 94.48%)",
                //     zIndex: 0,
                //   },
                // },
              }}>
              {title}
            </PortableTitle>
            <styled.div
              css={{
                color: "#373737",
                fontSize: { base: "15px", lg: "24px" },
                lineHeight: "133%",
                maxWidth: "840px",
              }}>
              <PortableText value={body} />
            </styled.div>
          </VStack>
        </styled.div>
      </Container>
    </styled.div>
  )
}

export default Columns
export type { Props as ColumnsProps }
